class Memberships {
    constructor(element) {
        this.el = element;
        this.capture_checkbox = this.el.querySelector(
            "[data-capture-auto-renew]",
        );

        this.spektrixCheckboxes = this.el.querySelectorAll(
            "input[data-set-autorenew]",
        );

        this.membershipWebComponent = this.el.querySelector(
            "spektrix-memberships",
        );

        if (this.el && this.spektrixCheckboxes?.length) {
            this.el.addEventListener(
                "change",
                this.handleAutoRenewChange.bind(this),
            );
        }
    }

    handleAutoRenewChange(event) {
        const isChecked = event.target.checked;

        this.spektrixCheckboxes.forEach((el) => {
            el.checked = isChecked;
        });

        if (this.membershipWebComponent) {
            if (isChecked) {
                this.membershipWebComponent.setAttribute("auto-renew", "");
            } else {
                this.membershipWebComponent.removeAttribute("auto-renew");
            }
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const membership_checkboxes = document.querySelectorAll(
        "[data-membership-options]",
    );

    if (membership_checkboxes) {
        membership_checkboxes.forEach((el) => {
            new Memberships(el);
        });
    }
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-capture-auto-renew]").forEach((checkbox) => {
        const card = checkbox.closest(".card");
        if (!card) {
            return;
        }

        const targets = card.querySelectorAll("spektrix-memberships");
        if (!targets.length) {
            return;
        }

        const syncAutoRenewAttr = (isChecked) => {
            targets.forEach((target) => {
                if (isChecked) {
                    target.setAttribute("auto-renew", "");
                } else {
                    target.removeAttribute("auto-renew");
                }
            });
        };

        syncAutoRenewAttr(checkbox.checked);

        checkbox.addEventListener("change", () => {
            syncAutoRenewAttr(checkbox.checked);
        });
    });
});
